export default "__VITE_ASSET__S7zFcAcf__"